(() => {
  'use strict';
  const host = document.querySelector('[data-morg-bundle-root]');
  const dataNode = document.getElementById('clc-morg-bundle-commerce');
  if (!host || !dataNode) return;
  const data = JSON.parse(dataNode.textContent);
  const media = matchMedia('(min-width: 1200px)');
  const state = { gallery: 0, busy: false, uncertain: false };
  const money = cents => new Intl.NumberFormat(data.locale || 'en-US', { style: 'currency', currency: data.currency }).format(Number(cents || 0) / 100);
  const rootUrl = String(data.root || '/').replace(/\/$/, '');
  const route = suffix => rootUrl + '/' + suffix;
  const activeVariant = () => data.variants.find(variant => variant.available) || data.variants[0];
  const request = async (suffix, options = {}) => {
    const response = await fetch(route(suffix), { credentials: 'same-origin', cache: 'no-store', ...options });
    const result = await response.json();
    if (!response.ok) { const error = new Error(result.description || result.message || 'Your bag could not be updated.'); error.rejected = true; throw error; }
    return result;
  };
  const status = message => host.querySelectorAll('[data-commerce-status]').forEach(node => { node.textContent = message; node.hidden = !message; });
  async function add(opener) {
    if (state.busy || state.uncertain) return;
    const variant = activeVariant();
    if (!variant?.available) return;
    const item = { id: variant.id, quantity: 1 };
    state.busy = true; render(); let accepted = false;
    try {
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.().map(section => section.section) || [];
      const result = await request('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item], sections, sections_url: location.pathname }) });
      accepted = true;
      if (drawer?.renderContents && sections.every(id => result.sections?.[id])) await drawer.renderContents(result, true);
      else { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener } })); }
    }
    catch (error) { state.uncertain = accepted || !error.rejected; status(state.uncertain ? 'Your bag may have been updated. Open the bag before trying again.' : error.message); }
    finally { state.busy = false; render(); }
  }
  function render() {
    const variant = activeVariant();
    const q = selector => [...host.querySelectorAll(selector)];
    q('[data-hero]').forEach(node => {
      const key = node.dataset.hero;
      const show = ({ a0: state.gallery === 0, b0: false, gel: state.gallery === 1, cbd: state.gallery === 4, gum: state.gallery === 2, oil: state.gallery === 3 })[key];
      node.style.display = show ? 'block' : 'none';
    });
    q('[data-th]').forEach(node => { node.style.display = 'block'; });
    q('[data-tbox]').forEach(node => {
      const selected = Number(node.dataset.tbox) === state.gallery;
      node.style.borderColor = selected ? '#201C27' : 'rgba(32,28,39,.18)';
      node.style.opacity = selected ? '1' : '.72';
    });
    q('[data-ben]').forEach(node => { node.style.display = node.dataset.ben === 'a' ? 'block' : 'none'; });
    q('[data-badge]').forEach(node => { node.style.display = 'none'; });
    q('[data-price-bundle]').forEach(node => { node.textContent = variant ? money(variant.price) : '$133.66'; });
    q('[data-price-full]').forEach(node => { node.textContent = variant ? money(variant.compareAtPrice || variant.price) : '$190.95'; });
    const blocked = !variant?.available || state.busy || state.uncertain;
    q('[data-add]').forEach(button => { button.disabled = blocked; button.textContent = state.busy ? 'ADDING…' : 'ADD TO BAG'; });
    if (!variant) status('The requested product variant has not been configured yet.');
    else if (!variant.available) status('This option is sold out.');
    else if (!state.uncertain) status('');
  }
  function bind() {
    host.querySelectorAll('[data-thumb]').forEach(node => node.addEventListener('click', () => { state.gallery = Number(node.dataset.thumb); render(); }));
    host.querySelectorAll('[data-add]').forEach(node => node.addEventListener('click', () => add(node)));
    for (const selector of ['[data-tab]', '[data-faq]']) {
      const buttons = [...host.querySelectorAll(selector)];
      buttons.forEach(button => button.addEventListener('click', () => {
        const key = selector === '[data-tab]' ? 'tab' : 'faq';
        buttons.forEach(other => {
          const selected = other === button;
          const panel = host.querySelector(selector === '[data-tab]' ? '[data-panel="' + other.dataset.tab + '"]' : '[data-faq-p="' + other.dataset.faq + '"]');
          if (panel) panel.style.display = selected ? 'block' : 'none';
          const chevron = host.querySelector(selector === '[data-tab]' ? '[data-tchev="' + other.dataset.tab + '"]' : '[data-fchev="' + other.dataset.faq + '"]');
          if (chevron) chevron.style.transform = selected ? 'rotate(180deg)' : 'none';
          other.setAttribute('aria-expanded', String(selected));
        });
      }));
    }
    const sticky = host.querySelector('[data-pagesmith-sticky]');
    const start = document.getElementById('pdp-bundle-top');
    const end = document.getElementById('pdp-sticky-end');
    if (sticky && start) {
      const tick = () => {
        const show = start.getBoundingClientRect().bottom < 0 && (!end || end.getBoundingClientRect().top > innerHeight);
        sticky.style.transform = show ? 'translateY(0)' : 'translateY(110%)';
        sticky.style.opacity = show ? '1' : '0';
        sticky.style.pointerEvents = show ? 'auto' : 'none';
      };
      addEventListener('scroll', tick, { passive: true });
      addEventListener('resize', tick, { passive: true });
      tick();
    }
    render();
  }
  function mount() {
    const layout = media.matches ? 'desktop' : 'mobile';
    host.replaceChildren(document.getElementById('clc-morg-bundle-' + layout).content.cloneNode(true));
    host.dataset.layout = layout;
    bind();
  }
  media.addEventListener('change', mount);
  mount();
})();
